var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgXLogo = function SvgXLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XLogo_svg__X",
    clipPath: "url(#XLogo_svg__clip0_0_136)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XLogo_svg__X_2",
    d: "M9.45034 0.500244H11.2904L7.27039 5.09488L11.9996 11.3471H8.29667L5.39638 7.55517L2.07779 11.3471H0.236597L4.53642 6.43266L-0.000366211 0.500244H3.7966L6.41821 3.96624L9.45034 0.500244ZM8.80453 10.2458H9.82414L3.24258 1.54377H2.14843L8.80453 10.2458Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "XLogo_svg__clip0_0_136"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "currentColor"
  })))));
};
export default SvgXLogo;